<template>
    <div
        :class="
            `convention-sections-table-cell ${isActive ? 'isActive' : ''} ${
                isActive && isCommon ? 'common' : ''
            }`
        "
        @click="onClick()"
    >
        <typo v-if="inactiveStatusLabel" name="body-10-normal">
            {{ inactiveStatusLabel }}
        </typo>
    </div>
</template>

<script>
import Vue from "vue";
import { isArray, find, some } from "lodash";
export default Vue.extend({
    props: [
        "sectionName",
        "cspCode",
        "isParentEnveloppe",
        "sectionsDraft",
        "cspConfig",
        "activeCspCodesBySectionName",
        "commonGroups",
    ],
    computed: {
        isDraft() {
            if (!this.isAvailableCsp) {
                return false;
            }
            return some(this.sectionsDraft || [], name => name === this.sectionName);
        },
        isAvailableCsp() {
            if (!this.cspConfig) return false;
            const availableCodes = this.cspConfig.availableCodes || [];
            const allIncluded = this.cspConfig.allIncluded || false;
            return allIncluded || find(availableCodes || [], c => c == this.cspCode);
        },
        isActive() {
            return (
                this.activeCspCodesBySectionName &&
                isArray(this.activeCspCodesBySectionName[this.sectionName]) &&
                this.activeCspCodesBySectionName[this.sectionName].some(
                    code => code === this.cspCode
                )
            );
        },
        isCommon() {
            const group = find(
                this.commonGroups[this.sectionName],
                g => g.indexOf(this.cspCode) > -1
            );
            return isArray(group) && group.slice(0, -1).indexOf(this.cspCode) > -1;
        },
        inactiveStatusLabel() {
            if (this.isActive) {
                return null;
            }
            if (this.isDraft) {
                return "prochainement en ligne";
            }
            if (this.isParentEnveloppe && this.isAvailableCsp) {
                return "pas de dispositions communes";
            }
            return "pas de dispositions";
        },
    },
    methods: {
        onClick() {
            if (this.isAvailableCsp && !this.isDraft) {
                this.$emit("goto", { sectionName: this.sectionName, cspCode: this.cspCode });
            }
        },
    },
});
</script>

<style scoped lang="sass">
.convention-sections-table-cell
    width: 100%
    height: 100%
    border: 1px solid transparentize($color-secondary, 0.2)
    text-align: center
    color: transparentize($color-secondary, 0.2)
    position: relative
    box-sizing: border-box
    display: flex
    align-items: center
    justify-content: center

    &.isActive
        background: lighten($color-main, 15%)
        border: 1px solid $color-main
        color: transparent
        cursor: pointer

    &.common:after
        position: absolute
        content: ''
        top: -1px
        bottom: -1px
        border-top: 1px solid $color-main
        border-bottom: 1px solid $color-main
        width: $grid-gutter * 2
        background: lighten($color-main, 15%)
        right: -$grid-gutter *2
        z-index: 1

@media print
    .convention-sections-table-cell .typo
        font-size: 6.5pt !important
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
</style>
